import { Stack, TextField } from "@mui/material";
import { BaseWizardCard } from "components/library/widgets/wizard-card/base-wizard-card";
import type { FormikForm } from "components/types/formik-types";
import type React from "react";
import type { DeliveryFormValues } from "../organisation-repurchase-delivery-page-view";

interface InternalReferenceCardProps {
  form: FormikForm<DeliveryFormValues>;
}

export const InternalReferenceCard = ({ form }: InternalReferenceCardProps) => {
  const onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => form.setFieldValue("internalReference", event.target.value);

  return (
    <BaseWizardCard
      title="Internal Reference"
      inputElement={
        <Stack spacing={2} width={"100%"}>
          <TextField
            label="Enter Internal Reference"
            variant="outlined"
            value={form.values.internalReference}
            onChange={(e) => onChange(e)}
            required={true}
            error={Boolean(form.errors?.internalReference ?? false)}
          />
        </Stack>
      }
    />
  );
};
